import SocialQuote from '@/components/elements/SocialQuote';
import TextWithLottie from '@/components/elements/TextWithLottie';
import { Divider, List, ListIcon, ListItem } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'next-i18next';
import { BiCheck } from 'react-icons/bi';
import * as animation from './data.json';

const LandingLottieFour = () => {
  const { t } = useTranslation(`landing`);
  return (
    <TextWithLottie
      isReverse
      title={t(`landing_lottie_four.header`)}
      lead={t(`landing_lottie_four.lead`)}
      animationData={(animation as any).default}
      alternativeImage="/images/landing/landing-lottie-4.svg"
    >
      <>
        <List spacing={3} listStylePos="outside">
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`landing_lottie_four.list_items.one`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`landing_lottie_four.list_items.two`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`landing_lottie_four.list_items.three`)}
          </ListItem>
        </List>
        <Divider
          borderColor="#6f7070"
          mt={8}
          mb={12}
          orientation="horizontal"
        />
        <SocialQuote
          avatar="https://firebasestorage.googleapis.com/v0/b/voltran-1.appspot.com/o/website%2Fsocial%2FSocial%20Proof_Ada%20Avlar%20Picture.jpg?alt=media&token=260cdd64-9149-40f3-9a3b-f6b179dc6d0e"
          company="11.Sınıf Sayısal Öğrencisi"
          name="Ada Avlar"
          quote="Voltran çok kullanışlı bir uygulama ve her şeye kolayca ulaşılabiliyor. Normalde benim uğraş sarfetmeden göremeyeceğim istatistikleri bana bir tıkla sunuyor."
        />
      </>
    </TextWithLottie>
  );
};

export default LandingLottieFour;
